import React from "react";
import styled from "styled-components";

const UnderlineTextButton = (props: any) => {
  const { className, label, onClick, children } = props;
  return (
    <TextButton className={className} onClick={onClick}>
      <span>{label}</span>
      {children}
    </TextButton>
  );
};

const TextButton = styled.button`
  font-family: HelveticaNeue-Light;
  font-size: 14px;
  color: #848991;
  text-decoration: underline;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export default UnderlineTextButton;
